import React, { Component, createRef } from 'react';
import Trumbowyg from 'src/react_components/form-helpers/trumbowyg';

type FeedbackIntroSectionProps = {
  content: string,
  categoryName: string,
  onChange: (text: string) => void,
}

type FeedbackIntroSectionState = {
  confirmingBannedWords: boolean,
  saving: boolean,
  contentEmpty: boolean,
  commentHelperId: number,
  updatedHtml: string | null
}

class FeedbackIntroSection extends Component<FeedbackIntroSectionProps, FeedbackIntroSectionState> {
  node = createRef<HTMLDivElement>();

  // trumbowyg textarea
  componentWillUnmount(): void {
    this.textarea.trumbowyg('destroy');
  }

  get textarea() { return $(this.node.current).find('.feedback-area-intro textarea'); }

  get editor() { return this.textarea.data('trumbowyg').$ed; }

  textChanged = () => {
    const text = this.editor.html();

    this.props.onChange(text);
  };

  render() {
    const { content, categoryName } = this.props;

    return (
      <div ref={this.node}>
        <Trumbowyg
          buttons={[
            ['strong', 'em', 'unorderedList'],
            ['link']
          ]}
          value={content}
          rows={6}
          placeholder={`Enter notes for ${categoryName}`}
          spellCheck
          readOnly
          wrapperClass="feedback-area-intro"
          autogrow
          onKeyDown={null}
          onInit={null}
          onChange={this.textChanged}
        />
      </div>
    );
  }
}

export default FeedbackIntroSection;
